import { render } from "./SectionTitleComponent.vue?vue&type=template&id=d214e704&scoped=true"
import script from "./SectionTitleComponent.vue?vue&type=script&lang=js"
export * from "./SectionTitleComponent.vue?vue&type=script&lang=js"

import "./SectionTitleComponent.vue?vue&type=style&index=0&id=d214e704&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d214e704"]])

export default __exports__